import * as React from 'react';
import { Form, Modal, ModalBody, ModalFooter, NumberInput, CustomButton, ButtonType, CustomSubmitButton, ModalSize, AlertMessage, AlertType, SpinnerWrapper } from "soprasteria-ui-library";
import { ISaveTreatment } from '../../../models/IPatientTreatment';
import { IPatientTreatment } from "../../../models/IPatientTreatment";
import { EmergencyTreatmentsDropdown } from "./EmergencyTreatmentsDropdown";
import { EmergencyTreatmentApi } from '../../../api/EmergencyTreatmentApi';
import { useAuth } from '../../../App';
import { setMessage } from '../../../helpers/MessageHelper';

interface IEmergencyTreatmentsModal {
    emergencyTreatmentReportId: number;
    validTreatmentCodes: IPatientTreatment[];
    onSubmitSuccess: () => void;
    onClose: () => void;
    renderForm: boolean;
    isFetching: boolean;
}

export const EmergencyTreatmentsModal: React.FunctionComponent<IEmergencyTreatmentsModal> = ({ emergencyTreatmentReportId, validTreatmentCodes, onSubmitSuccess, onClose, renderForm, isFetching }) => {

    const [isSubmitting, setIsSubmitting] = React.useState<boolean>(false);
    const [errorMessage, setErrorMessage] = React.useState<string>();

    const auth = useAuth();
    const api = new EmergencyTreatmentApi(auth);

    React.useEffect(() => {
        if (renderForm) {
            setErrorMessage("");
            document.getElementById("open-treatment-modal")?.click();
        }
    }, [renderForm])

    const saveTreatment = (treatment: ISaveTreatment) => {
        setIsSubmitting(true);
        api.addEmergencyTreatment(emergencyTreatmentReportId, treatment, () => {
            document.getElementById("close-add-emergency-treatment-modal")?.click();
            onSubmitSuccess();
        }, (message) => {
            const newMessage = setMessage(message, errorMessage ?? "");
            setErrorMessage(newMessage);
        }, () => { setIsSubmitting(false) });
    }

    return (
        <Modal id="treatment-modal" modalSize={ModalSize.large} header="Lägg till en åtgärdskod">
            <SpinnerWrapper isLoading={isFetching}>
                {
                    renderForm ?
                        <Form onSubmit={saveTreatment}>
                            <ModalBody>
                                <AlertMessage alertType={AlertType.danger} duration={3000}>{errorMessage}</AlertMessage>
                                <div className="row">
                                    <div className="col-12">
                                        <EmergencyTreatmentsDropdown treatments={validTreatmentCodes} name="treatmentCodeId" required />
                                        <NumberInput defaultValue="1" label="Antal" name="quantity" inlineLabel disabled/>
                                    </div>
                                </div>
                            </ModalBody>
                            <ModalFooter>
                                <div className="text-right btn-group" role="group">
                                    <CustomButton buttonType={ButtonType.general} id="close-add-emergency-treatment-modal" buttonText="Avbryt" data-dismiss="modal" onClick={() => onClose()} />
                                    <CustomSubmitButton isLoading={isSubmitting} disabled={!renderForm}>Spara</CustomSubmitButton>
                                    <input type="hidden" data-toggle="modal" id="open-treatment-modal" data-target="#treatment-modal" />
                                </div>
                            </ModalFooter>
                        </Form>
                        : null
                }
            </SpinnerWrapper>
        </Modal>
    )
}